
export default {
    props: {
        background: {
            type: String,
            required: false,
            default: () => '/img/background-image-newsletter.jpg'
        },
        title: {
            type: String,
            required: false,
            default: () => 'shared.join_community'
        }
    },
    data: () => ({
        id: 12,
        form: {
            valid: false,
            email: {
                value: null,
                rules: [
                    v => /.+@.+/.test(v) || 'El E-mail introducido no es válido',
                ]
            }
        }
    })
}
